import { render, staticRenderFns } from "./PropertyView.vue?vue&type=template&id=40cc1da9&scoped=true"
import script from "./PropertyView.vue?vue&type=script&lang=ts"
export * from "./PropertyView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc1da9",
  null
  
)

export default component.exports